import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'inArrayPipe'
})

export class InArrayPipe<T extends {[key: string]: any}> implements PipeTransform {
    transform(element: T, array: T[], property: string): boolean {
        return array.some(obj => obj[property] === element[property]);
    }
}
